var Base = require('_js/base');

function CourseFactsBlock() {
  this.init();
}

CourseFactsBlock.prototype = new Base();

CourseFactsBlock.prototype.init = function() {
  $('.course-facts-mobile-tab').on('click', function() {
    var tab = $(this).closest('[data-tab]');
    var tabNumber = tab.data('tab');
    var isActive = tab.hasClass('is-active');

    if (!isActive) {
      var $allTabs = $('[data-tab]');
      var $activeTabs = $("[data-tab='" + tabNumber + "']");
      $allTabs.removeClass('is-active');
      $allTabs.parent().removeClass('is-active');
      $activeTabs.addClass('is-active');
      $activeTabs.parent().addClass('is-active');
    }
  });
};

module.exports = CourseFactsBlock;
